import * as React from 'react';
import classnames from 'classnames';
import { Col, Row } from 'react-grid-system';
import styles from './FormField.styl';
const col12 = 12;
const col4 = 4;
const col8 = 8;
const FormField = ({ t, field, label, namespace, isOptional, dense, inline, children }) => {
    const renderLabel = (label) => {
        return (React.createElement("div", { className: classnames(styles.label, { [styles.dense]: dense, [styles.notInline]: !inline }) }, `${label}${inline ? ':' : ''}`));
    };
    let labelNode = null;
    if (label) {
        labelNode = typeof label === 'string' ? renderLabel(label) : label;
    }
    else if (field && field.label) {
        labelNode = renderLabel(t(field.label));
    }
    return (React.createElement(Row, { justify: 'between', align: 'center', className: classnames(styles.wrapper, { [styles.dense]: dense }) },
        React.createElement(Col, { xs: inline ? col4 : col12 },
            labelNode,
            isOptional && (React.createElement("div", { className: classnames(styles.optional, { [styles.notInline]: !inline }) }, t('ui.field.optional', namespace ? { ns: namespace } : undefined)))),
        React.createElement(Col, { xs: inline ? col8 : col12 }, children)));
};
export default FormField;
